import React, { useEffect, useState } from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import './WorkExperience.css';
import { TimelineItem } from '../types';
import { getTimeline } from '../queries/getTimeline';

// Import your new local icon components
import WorkIcon from './icons/WorkIcon';     // Adjust path if needed
import SchoolIcon from './icons/SchoolIcon';   // Adjust path if needed
import StarIcon from './icons/StarIcon';       // Adjust path if needed


const WorkExperience: React.FC = () => {
  const [timeLineData, setTimeLineData] = useState<TimelineItem[] | null>(null);

  useEffect(() => {
    async function fetchTimelineItem() {
      const data = await getTimeline();
      setTimeLineData(data);
    }
    fetchTimelineItem();
  }, []);

  if (!timeLineData) return <div>Loading...</div>;

  return (
    <>
      <div className="timeline-container">
        <h2 className="timeline-title">📅 Work Experience & Education Timeline</h2>
      </div>
      <VerticalTimeline>
        {timeLineData.map((item, index) => (
          <VerticalTimelineElement
            key={index}
            className={`vertical-timeline-element--${item.timelinetype}`}
            contentStyle={
              item.timelinetype === "work"
                ? { background: 'rgb(33, 150, 243)', color: '#fff' }
                : { background: 'rgb(233, 30, 99)', color: '#fff' } // Education style
            }
            contentArrowStyle={{ borderRight: item.timelinetype === "work" ? '7px solid rgb(33, 150, 243)' : '7px solid rgb(233, 30, 99)' }}
            date={item.daterange}
            iconStyle={
              item.timelinetype === "work"
                ? { background: 'rgb(33, 150, 243)', color: '#fff' }
                : { background: 'rgb(233, 30, 99)', color: '#fff' }
            }
            // The icons are now replaced with your local components
            icon={item.timelinetype === "work" ? <WorkIcon /> : <SchoolIcon />}
          >
            <div style={{ color: item.timelinetype === "work" ? 'white' : 'black' }}>
                <h3 className="vertical-timeline-element-title">{item.title}</h3>
                <h4 className="vertical-timeline-element-subtitle">{item.name}</h4>
                {item.techstack && <p className="vertical-timeline-element-tech">🔧 {item.techstack}</p>}
                {/* Check if summarypoints is an array before rendering */}
                {Array.isArray(item.summarypoints) ? (
                    <ul>
                        {item.summarypoints.map((point, i) => <li key={i}>{point}</li>)}
                    </ul>
                ) : <p>{item.summarypoints}</p>}
            </div>
          </VerticalTimelineElement>
        ))}
        <VerticalTimelineElement
          iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
          icon={<StarIcon />}
        />
      </VerticalTimeline>
    </>
  );
};

export default WorkExperience;